<template>
    <div id="storeFile" class="page-content">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>店铺档案</el-breadcrumb-item>
      </el-breadcrumb>
  
      <section class="seaerch-wrapper">
        <el-form class="search-form" style="margin-left: -30px;">
          <el-form-item label="平台" :label-width="formLabelWidth">
            <el-select v-model="form.platform_code" filterable clearable placeholder="请选择" size="small">
              <el-option
                v-for="item in platformList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="旺旺" :label-width="formLabelWidth">
            <el-input clearable onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" v-model="form.wangwang" placeholder="请输入" size="small"></el-input>
          </el-form-item>
          <el-form-item label="店铺名称" :label-width="formLabelWidth">
            <el-input clearable onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" v-model="form.shopname" placeholder="请输入" size="small"></el-input>
          </el-form-item>
          <el-form-item label="状态" :label-width="formLabelWidth">
            <el-input clearable onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" v-model="form.status" placeholder="请输入" size="small"></el-input>
          </el-form-item>
          
          <el-form-item>
            <el-button size="small" class="search-btn" @click="theQuery(1)">查询</el-button>
          </el-form-item>
        </el-form>
      </section>
  
      <div class="page">
        <el-row style="margin-bottom: 5px;">
          <el-col :span="10">
            <el-button style="margin-right: 10px;" @click="buyNewadd('新增')" size="small" icon="el-icon-plus" type="primary" v-if="userData.logintype != 'HCM'">新增</el-button>
          </el-col>
        </el-row>
        <el-table ref="multipleTable"
          :data="tableData"
          style="width: 100%"
          @selection-change="handleSelectionChange"
          v-loading="tableDataLoading"
          element-loading-text="拼命加载中"
          element-loading-spinner="el-icon-loading"
          >
  
          <el-table-column type="selection" width="55" fixed></el-table-column>
          <el-table-column label="序号" width="80" fixed>
            <template slot-scope="scope">
              {{scope.$index+1}}
            </template>
          </el-table-column>
          <el-table-column label="平台" prop="platformCode">
            <template slot-scope="scope">
              {{scope.row.platformCode | platformChinese}}
            </template>
          </el-table-column>
          <el-table-column label="店铺名称" prop="shopName"></el-table-column>
          <el-table-column label="旺旺名称" prop="wangwang"></el-table-column>
          <el-table-column label="店铺运营负责人" prop="shopoperate"></el-table-column>
          <el-table-column label="联系方式" prop="shopoperatecontact"></el-table-column>
          <el-table-column label="审核状态">
            <template slot-scope="scope">
              <span v-if="scope.row.status == 1">
                待审核
              </span>
              <span v-if="scope.row.status == 2">
                通过
              </span>
              <span v-if="scope.row.status == 3">
                驳回
              </span>
            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" width="200px">
            <template slot-scope="scope">
              <div style="color: #108cee;cursor: pointer;float: left;padding-right: 10px;" @click.stop="buyNewadd(scope.row)" v-if="userData.logintype != 'HCM' && scope.row.status == 3">
                <i class="el-icon-edit-outline"></i>
                <span>编辑</span>
              </div>
              <div style="color: #108cee;cursor: pointer;float: left;padding-right: 10px;" @click.stop="openDelete(scope.row.id)" v-if="userData.logintype != 'HCM' && scope.row.status == 3">
                <i class="el-icon-delete"></i>
                <span>删除</span>
              </div>
              <div style="color: #108cee;cursor: pointer;float: left;" @click.stop="clickDrawer(scope.row)" v-if="userData.logintype == 'HCM' && scope.row.status == 1">
                <i class="el-icon-edit"></i>
                <span>审批</span>
              </div>
              <div style="color: #108cee;cursor: pointer;float: left;" @click.stop="clickDrawer(scope.row)" v-if="userData.logintype != 'HCM'">
                <i class="el-icon-view"></i>
                <span>查看</span>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div v-if="tableData.length > 0">
          <pagination
            :currentPage="currentPage" :pageSizes="[10, 20, 30, 40]"
            :total="totalNum" @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange">
          </pagination>
        </div>
      </div>
      <!-- 批量删除 -->
      <el-dialog :visible.sync="deleteShow" width="360px" title="提示" style="margin-top: 10%;">
        <div style="display: flex;width: 100%;justify-content:center;">
          <i class="el-icon-warning" style="color:#faad14;font-size: 35px;"></i>
          <div>
            <div style="font-size: 16px;" v-if="sureDel == '单'">你确认要删除该店铺信息吗？</div>
            <div style="font-size: 16px;" v-else>你确认要删除勾选的{{openNumber}}项店铺信息吗？</div>
  
            <div style="font-size: 14px;">删除后
              <span style="color: #e90e24;font-size: 14px;">店铺信息将无法恢复</span>
            </div>
          </div>
        </div>
        <div slot="footer" class="dialog-footer" id="dialogPrimary">
          <el-button type="primary" @click="openPhone(1)" size="small">确 定</el-button>
          <el-button @click="deleteShow = false" style="margin-left: 10px;"  size="small" type="TheCustom">取 消</el-button>
        </div>
      </el-dialog>
      <!-- 新增 -->
      <el-dialog
        title="新增"
        :visible.sync="buyNewShow"
        width="640px"
        :close-on-click-modal='false'>
        <div class="page2" style="height: 500px;overflow-y: auto;">
          <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="140px">
            <el-form-item label="平台:" prop="platformCode">
              <el-select v-model="ruleForm.platformCode" filterable clearable style="width: 425px;" placeholder="请选择" size="small">
                <el-option
                  v-for="item in platformList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="旺旺名称:">
              <el-input v-model="ruleForm.wangwang" placeholder="请输入" onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" clearable style="width: 425px;" size="small"></el-input>
            </el-form-item>
            <el-form-item label="店铺名称:" prop="shopName">
              <el-input v-model="ruleForm.shopName" placeholder="请输入" onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" clearable style="width: 425px;" size="small"></el-input>
            </el-form-item>
            <el-form-item label="店铺首页地址:">
              <el-input v-model="ruleForm.shopUrl" placeholder="请输入" onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" clearable style="width: 425px;" size="small"></el-input>
            </el-form-item>
            <el-form-item label="店铺运营负责人:">
              <el-input v-model="ruleForm.shopoperate" placeholder="请输入" onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" clearable style="width: 425px;" size="small"></el-input>
            </el-form-item>
            <el-form-item label="店铺运营联系方式:">
              <el-input v-model="ruleForm.shopoperatecontact" placeholder="请输入" onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" clearable style="width: 425px;" size="small"></el-input>
            </el-form-item>
            <el-form-item label="备注:">
              <el-input v-model="ruleForm.remark" placeholder="请输入" onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" clearable style="width: 425px;" size="small"></el-input>
            </el-form-item>
            <el-form-item label="地区:">
              <el-input v-model="ruleForm.region" placeholder="请输入" onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" clearable style="width: 425px;" size="small"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" style="margin-left: 100px;" @click="sureBuy('ruleForm')" size="small" :loading="buyLoading">确 定</el-button>
          <el-button @click="buyNewShow = false" type="TheCustom" size="small" style="margin-left: 16px;">取 消</el-button>
        </span>
      </el-dialog>
  
      <el-drawer
        :with-header="false"
        title="111"
        :visible.sync="buyDrawer"
        size="840px">
        <div style="padding: 20px;background-color: white;">
          <span style="margin-left: 20px;font-size: 16px;font-weight: 600;">
            {{drawerData.shopName}}
          </span>
          <span style="color: #1e1e1ea5;margin-left: 30px;">
            <span v-if="drawerData.status == 1">
                待审核
              </span>
              <span v-if="drawerData.status == 2">
                通过
              </span>
              <span v-if="drawerData.status == 3">
                驳回
              </span>
          </span>
          <span style="color: #1e1e1ea5;float: right;">
            <i class="el-icon-close" style="font-size: 19px;font-weight: 400;cursor: pointer;" @click="buyDrawer = false">
            </i>
          </span>
          <span style="color: #1e1e1ea5;margin-left: 20px;margin-right: 40px;float: right;">
            {{drawerData.createtime | fullTime}}
          </span>
          
        </div>
        <el-card class="margin_bottom20 no_margin" style="margin: 20px;">
          <el-form label-width="130px">
            <div style="font-size: 14px;font-weight: 600;">
              基本信息
            </div>
            
            <el-form-item label="平台:">
              {{drawerData.platformCode | platformChinese}}
            </el-form-item>
            <el-form-item label="旺旺名称:">
              {{drawerData.wangwang}}
            </el-form-item>
            <el-form-item label="店铺名称:">
              {{drawerData.shopName}}
            </el-form-item>
            <el-form-item label="店铺首页地址:">
              <el-link type="primary" :href="drawerData.shopUrl" target="_blank" :underline="false">
                <div style="overflow:hidden;
                  text-overflow:ellipsis;
                  white-space:nowrap;
                  width: 600px;">
                    {{drawerData.shopUrl}}
                </div>
              </el-link>
            </el-form-item>
            <el-form-item label="店铺运营负责人:">
              {{drawerData.shopoperate}}
            </el-form-item>
            <el-form-item label="店铺运营联系方式:">
              {{drawerData.shopoperatecontact}}
            </el-form-item>
            <el-form-item label="备注:">
              {{drawerData.remark}}
            </el-form-item>
            <el-form-item label="地区:">
              {{drawerData.region}}
            </el-form-item>

          </el-form>
        </el-card>

        <el-card style="margin: 20px;" v-if="drawerData.status == 3 && userData.logintype != 'HCM'">
          <div style="font-size: 14px;font-weight: 600;">
            审批
          </div>
          <el-form label-width="130px">
            <el-form-item label="驳回说明:">
              <el-input
                type="textarea"
                :rows="4"
                placeholder="请输入驳回说明"
                v-model="drawerData.reason"
                disabled>
              </el-input>
            </el-form-item>
          </el-form>
          
        </el-card>

        <el-card style="margin: 20px;" v-if="drawerData.status == 1 && userData.logintype=='HCM'">
          <div style="font-size: 14px;font-weight: 600;">
            审批
          </div>
          <el-form label-width="130px">
            <el-form-item label="驳回说明:" required v-if="bhStatus == 4">
              <el-input
                type="textarea"
                :rows="4"
                placeholder="请输入驳回说明"
                v-model="reason">
              </el-input>
            </el-form-item>
            <el-form-item label="驳回说明:" required v-if="bhStatus == 3">
              <el-input
                type="textarea"
                :rows="4"
                placeholder="请输入驳回说明"
                v-model="drawerData.reason">
              </el-input>
            </el-form-item>
            <el-form-item style="text-align: right;"  v-if="bhStatus != 4">
              <el-button type="primary" @click="examineShopExamine(2)" size="small">通 过</el-button>
              <el-button type="danger" @click="examineShopExamine(4)" size="small" style="margin-left: 16px;">驳 回</el-button>
            </el-form-item>
            <el-form-item style="text-align: right;"  v-if="bhStatus == 4">
              <el-button type="primary" @click="examineShopExamine(3)" size="small">确 认</el-button>
              <el-button @click="bhStatus = ''" size="small" style="margin-left: 16px;">取 消</el-button>
            </el-form-item>
          </el-form>
          
        </el-card>
      </el-drawer>
    </div>
  </template>
  
  <script>
    import pagination from "../../../components/dataTable/pagination";
    export default {
      data() {
        return {
          platformList: [
            { value: 'TB', label: '淘宝' },
            { value: 'TM', label: '天猫' },
            { value: 'JD', label: '京东' },
            { value: 'SN', label: '苏宁' },
            { value: '1688', label: '1688' },
            { value: 'DD', label: '当当' },
            { value: 'PDD', label: '拼多多' },
          ],
          rules: {
            platformCode: [
              { required: true, message: '请选择平台', trigger: 'change' }
            ],
            shopName: [
            { required: true, message: '请输入店铺名称', trigger: 'blur' },
            ],
          },
          ruleForm: {
            platformCode: '', 
            wangwang: '', 
            shopName: '', 
            shopUrl: '', 
            shopoperate: '', 
            shopoperatecontact: '', 
            remark: '', 
            region: '',
          },
          reason: '',
          drawerData: [],
          buyDrawer: false,
          tableDataLoading: false,
          buyLoading: false,
          buyNewShow: false,
          form: {
            platform_code: '',
            status: '',
            shopname: '',
            wangwang: '',
          },
          tableData: [],
          multipleSelection: [],
          checkAll: 0,
          delIds: [],
          deleteShow: false,
          openNumber: 0,
          totalNum: 100,
          pageNo: 1,
          pageSize: 10,
          currentPage: 1,
          formLabelWidth: '120px',
          rowNum: 0,
          sureDel: '',
          bhStatus: '',
          userData: {},
          rowId: '',
        }
      },
      mounted() {
        this.userData=JSON.parse(localStorage.getItem('userData'));//获取用户信息
        this.theQuery();
      },
      methods: {
        // 详情
        clickDrawer(row) {
          let params = {
            id: row.id
          }
          fetch({
            url: "hcm/hcmShop/getShopExamineById",
            method: "get",
            params: params,
            noFormat: true,
            responseType: "text"
          }).then(result => {
            
            let res = JSON.parse(result);
            let {data}=res
            console.log(res)
            if(res.status == '10000'){
              this.buyDrawer = true
              this.drawerData = res.data
              this.reason = ''
            } else {
              this.$message.error(res.message)
            }
          })
        },
        examineShopExamine(status) {
          this.bhStatus = status
          if (this.bhStatus != 4) {
            if (this.bhStatus == 3 && !this.reason) {
              this.$message({
                message: '请填写驳回说明',
                type: 'warning'
              });
              return
            }
            let params={
              id: this.drawerData.id,
              status: status
            }
            if (this.reason) {
              params.reason = this.reason
            }
            fetch({
              url: "hcm/hcmShop/examineShopExamine",
              method: "post",
              params: params,
              noFormat: true,
              responseType: "text"
            }).then(result => {
              let res = JSON.parse(result);
              let {data}=res
              if(res.status == '10000'){
                this.$message({
                  message: '新增成功',
                  type: 'success'
                });
                console.log(this.drawerData)
                this.clickDrawer(this.drawerData)
                this.theQuery()
              } else {
                this.$message.error(res.message)
              }
            })
          }
          
          
        },
        // 删除
        openDelete(id) {
          this.delIds = []
          this.delIds.push(id)
          this.sureDel = '单'
          this.deleteShow = true
        },
        // 确认新增、编辑
        sureBuy(formName) {
          this.$refs[formName].validate((valid) => {
            if (valid) {
              this.buyLoading = true
              let url = ''
              if (this.ruleForm.id) {
                url = 'hcm/hcmShop/updateShopExamine'
              } else {
                url = 'hcm/hcmShop/insertShopExamine'
              }
              fetch({
                url: url,
                method: "post",
                data: JSON.stringify(this.ruleForm),
                headers: {
                  'Content-Type': 'application/json',
                },
                noFormat: false,
                responseType: "json"
              }).then(result => {
                if(result.status == '10000'){
                  this.$message({
                    message: '新增成功',
                    type: 'success'
                  });
                  this.buyNewShow = false;
                  this.buyLoading = false
                  this.theQuery();
                } else {
                  this.$message.error(res.message)
                  this.buyLoading = false
                }
              })
            } else {
              console.log('error submit!!');
              return false;
            }
          })
        },
        // 新增
        buyNewadd(data) {
          console.log(data)
          this.buyNewShow = true
          if (data != '新增') {
            this.ruleForm = data
          } else {
            this.ruleForm = {
              platformCode: '', 
              wangwang: '', 
              shopName: '', 
              shopUrl: '', 
              shopoperate: '', 
              shopoperatecontact: '', 
              remark: '', 
              region: '',
            }
          }
        },
        // 数据来源
        theQuery(e) {
          this.tableDataLoading = true
          if (e == 1) {
            this.pageNo = 1
            this.currentPage = 0
          }
          let params={
            pageNo: this.pageNo,
            pageSize: this.pageSize,
          }
          if (this.form.platform_code) {
            params.platform_code = this.form.platform_code;
          }
          if (this.form.wangwang) {
            params.wangwang = this.form.wangwang;
          }
          if (this.form.shopname) {
            params.shopname = this.form.shopname;
          }
          if (this.form.status) {
            params.status = this.form.status;
          }
          fetch({
            url: "hcm/hcmShop/getShopExamineList",
            method: "get",
            params: params,
            noFormat: true,
            responseType: "text"
          }).then(result => {
            let res = JSON.parse(result);
            let {data}=res
            if(res.status == '10000'){
              console.log(data)
              console.log(res)
              this.tableDataLoading = false
              this.tableData = data.content;
              this.totalNum = data.totalElements;
            } else {
              this.tableDataLoading = false
              this.$message.error(res.message)
            }
          })
        },
        // table多选
        toggleSelection(rows) {
          if (rows) {
            rows.forEach(row => {
              this.$refs.multipleTable.toggleAllSelection(row);
              this.rowNum = row.length
              this.checkAll = 2
              this.openNumber = this.totalNum
            });
          } else {
            this.$refs.multipleTable.clearSelection();
            this.checkAll = 1
            this.openNumber = 0
          }
        },
        handleSizeChange(val) {
          this.pageSize = `${val}`
          this.theQuery();
        },
        handleCurrentChange(val) {
          this.pageNo = `${val}`
          this.theQuery();
        },
        handleSelectionChange(val) {
          if (val.length > 0) {
            this.multipleSelection = val;
            if (this.rowNum == val.length && this.checkAll == 2) {
              this.openNumber = this.totalNum
            } else if (val.length != 0){
              this.openNumber = val.length
              this.checkAll = 1
            }
          } else {
            this.multipleSelection = val
            this.checkAll = 1
            this.openNumber = val.length
          }
        },
        // 删除
        batchEnabled() {
          if (this.multipleSelection.length != 0) {
            this.deleteShow = true;
            if (this.checkAll == 2) {
              this.openNumber = this.totalNum;
            } else {
              this.openNumber = this.multipleSelection.length;
            }
          } else {
            this.$message({
              message: '请选择要删除的店铺',
              type: 'warning'
            });
          }
        },
        // 确认删除
        openPhone(e) {
          var arr = [];
          this.multipleSelection.forEach((val,index,val_arr)=>{
            arr.push(val.id)
          });
          console.log(arr)
          let params = {}
          if (this.form.platform_code) {
            params.platform_code = this.form.platform_code;
          }
          if (this.form.wangwang) {
            params.wangwang = this.form.wangwang;
          }
          if (this.form.shopname) {
            params.shopname = this.form.shopname;
          }
          if (this.form.status) {
            params.status = this.form.status;
          }
          if (this.checkAll == 2) {
            params.ids = 'checkAll'
          } else {
            console.log(this.delIds)
            console.log(arr)
            if (arr.length > 0) {
              this.delIds = arr.join();
              params.ids = this.delIds
            } else {
              params.ids = this.delIds.join()
            }
          }
          console.log(params.ids)
          fetch({
            url: "hcm/hcmShop/deleteShopExamine",
            method: "post",
            params: params,
            noFormat: true,
            responseType: "text"
          }).then(result => {
            let res = JSON.parse(result);
            let {data}=res
            if(res.status == '10000'){
              this.theQuery();
              this.deleteShow = false;
              this.checkAll = 1
            } else {
              this.$message.error(res.message)
            }
          })
        },
      },
      components: {
        pagination
      }
    }
  </script>
  <style lang="scss">
  #storeFile {
    .el-drawer {
      background-color: rgba(240, 242, 245, 1) !important;
    }
    .el-drawer .el-drawer__body {
      padding: 0;
    }
    .page {
      padding: 20px;
      margin-top: 10px;
      background-color: white;
    }
    .prompt {
      height: 28px;
      border: 1px solid #108cee;
      background-color: #e6f7ff;
      border-radius: 5px;
      line-height: 28px;
      margin-bottom: 8px;
      margin-top: 8px;
    }
    .promptFont{
      color: #108cee;
      font-size: 14px;
      margin-left: 3px;
      margin-right: 3px;
    }
    .promptFont2{
      color: #108cee;
      font-size: 14px;
      margin-left: 3px;
      margin-right: 3px;
      cursor: pointer;
    }
    .el-upload--picture-card {
      width: 104px;
      height: 104px;
      line-height: 104px;
    }
    .el-upload-list--picture-card .el-upload-list__item {
      width: 104px;
      height: 104px;
    }
    .el-table th {
      background-color: #f3f7ff !important;
    }
    .el-table__empty-text{
      padding-top: 100px;
      background: url("../../../assets/img/other/nodata.svg") no-repeat;
      background-position: center 66px;
    }
    #dialog {
      .el-dialog__header {
        padding: 20px 20px 10px;
        border-bottom: 1px solid #d9d9d9;
      }
    }
    .el-button+.el-button {
      margin-left: 1px;
    }
    .el-button--TheCustom {
      color: #666;
      border-color: #D9D9D9;
      background-color: #fff;
    }
    .el-button--TheCustom:hover  {
      color: #666;
      border-color: #ded2b8;
      background-color: #faf9f5;
    }
    #dialogPrimary {
      .el-button--primary {
        color: #FFF;
        background-color: #bda571;
        border-color: #bda571;
      }
      .el-button--primary:hover {
        color: #FFF;
        background-color: #c0ae8a;
        border-color: #c0ae8a;
      }
    }
  
  }
  </style>
  